/** @jsx jsx */
import React, { useMemo } from "react";
import { jsx, css } from "@emotion/react";
import { Tooltip } from "antd";
import { connect } from "dva";
import { getContrast } from "@/utils/color";
import styles from "./styles.less";

const StatusStep = ({
  step,
  current,
  icon,
  title,
  toolTipDescription,
  color,
  overrideActive,
  activeBackgroundColor,
  inactiveBackgroundColor,
}) => {
  const { styleConfig, active } = useMemo(() => {
    if (overrideActive !== undefined) {
      return {
        active: overrideActive,
        styleConfig: {
          "&:before": {
            background: inactiveBackgroundColor || "#EBECF0",
          },
          "&:after": {
            background: inactiveBackgroundColor || "#EBECF0",
          },
        },
      };
    }

    if (step <= current) {
      return {
        active: true,
        styleConfig: {
          "&:before": {
            background: activeBackgroundColor || "#2D6AC4",
          },
          "&:after": {
            background: activeBackgroundColor || "#2D6AC4",
          },
        },
      };
    }

    return {
      active: false,
      styleConfig: {
        "&:before": {
          background: inactiveBackgroundColor || "#EBECF0",
        },
        "&:after": {
          background: inactiveBackgroundColor || "#EBECF0",
        },
      },
    };
  }, [overrideActive, step, current, activeBackgroundColor, inactiveBackgroundColor]);

  const textColor = useMemo(() => {
    if (active) {
      return getContrast(activeBackgroundColor || "#2D6AC4", color);
    }

    return getContrast(inactiveBackgroundColor || "#EBECF0");
  }, [active, activeBackgroundColor, inactiveBackgroundColor, color]);

  const stepStyle = css(styleConfig);

  return (
    <Tooltip color="#fff" title={toolTipDescription}>
      <div className={`${styles.customStep}`} css={stepStyle}>
        {icon && (
          <div
            style={{
              padding: 5,
              color: textColor,
            }}
          >
            {icon}
          </div>
        )}
        <div
          style={{
            color: textColor,
            fontWeight: 600,
          }}
        >
          {title}
        </div>
      </div>
    </Tooltip>
  );
};

const StatusSteps = props => {
  const { children } = props;

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { current: props.current });
    }
    return child;
  });

  return <div className={styles.stepsWrapper}>{childrenWithProps}</div>;
};

StatusSteps.StatusStep = StatusStep;

export default connect(() => ({}))(StatusSteps);
